// extracted by mini-css-extract-plugin
export default {"divider":"divider_divider__13649","fade-in":"divider_fade-in__4kpuU"};